import { node, shape, string } from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Text } from 'react-native';

import { C } from '../../common';
import { Consumer } from '../../context';
import { ENV, THEME } from '../../reactor/common';
import { Touchable } from '../../reactor/components';

const { AMPLITUDE: { CLICK_TYPE: { IN, OUT }, ON_CLICK } } = C;
const { IS_WEB, IS_SERVER } = ENV;
const { COLOR } = THEME;
const DOMAIN = 'minube.com';
const props = (to, inherit = {}) => ({
  target: to,
  type: to.search(DOMAIN) > -1 ? IN : OUT,
  ...inherit,
});

const Uri = ({
  children, event, eventProps, target, to, ...inherit
}) => (
  <Consumer>
    {({ logEvent, onUri }) => (
      React.createElement(
        !IS_SERVER && IS_WEB && !target ? RouterLink : Touchable,
        !IS_SERVER && IS_WEB && !target
          ? {
            onClick: () => {
              logEvent(event, props(to, eventProps));
            },
            style: inherit.style && { textDecoration: 'none' },
            target,
            to,
            rippleColor: COLOR.WHITE,
            ...inherit,
          }
          : {
            onPress: () => {
              logEvent(event, props(to, eventProps));
              onUri(to, target);
            },
            style: inherit.style,
            rippleColor: COLOR.WHITE,
          },
        children,
      )
    )}
  </Consumer>
);

Uri.propTypes = {
  children: node,
  event: string,
  eventProps: shape({}),
  target: string,
  to: string,
};

Uri.defaultProps = {
  children: <Text />,
  event: ON_CLICK,
  eventProps: undefined,
  target: undefined,
  to: undefined,
};

export default Uri;
